import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { useDispatch } from 'react-redux';

const getFieldValue = (record, fieldId) => record?.[fieldId]?.value ?? '';

const formatAddress = value => {
  if (!value || typeof value === 'string') return value || '';

  return [value.street, value.street2, value.city, value.state || value.region, value.zip || value.postal]
    .filter(Boolean)
    .join(', ');
};

export const LocationsHomepage = () => {

  const dispatch = useDispatch();
  const logoutUser = () => {
    dispatch({ type: 'LOG_OUT', payload: null });
    sessionStorage.setItem('currentUser', null);
    window.location = "/";
  };

  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState([])

  useEffect(() => {
    fetchLocations();
  }, [])

  const fetchLocations = async() => {
    const response = await fetch("/apilocations/");
    const locations = await response.json();
    if (locations && locations.sessionExpired) {
      logoutUser();
      return;
    }
    setLocations(locations);
    setFilteredLocations(locations)
  }

  const redirectToLocationPage = (e, locationId, portalApp) => {
    const appQuery = portalApp === 'fire_pest' ? '?app=fire_pest' : '';
    navigate(`/location/${locationId}${appQuery}`, {state: {id: locationId}});
  }

  const handleChangeInput = (e) => {
    const searchTerm = e.target.value;
    const filteredLocations = locations.filter(item => {
      const searchStringLocationNumber = String(getFieldValue(item, 66));
      const searchStringLocationCode = String(getFieldValue(item, 35));
      const searchStringAddress = formatAddress(getFieldValue(item, 8));
      const normalizedSearchTerm = searchTerm.toLowerCase();
      return searchStringLocationNumber.toLowerCase().includes(normalizedSearchTerm) ||
        searchStringLocationCode.toLowerCase().includes(normalizedSearchTerm) ||
        searchStringAddress.toLowerCase().includes(normalizedSearchTerm);
    });
    setFilteredLocations(filteredLocations)
  }

  // const handleRedirectCreateTicket = () => {
  //   navigate("/createTicket");
  // }

  return (
  <div className="locations">
  <div className="locationsList">
    <h2>Locations</h2>
    <div className="searchInputWrapper inputWrapper">
      <input aria-label="Search locations" placeholder="Search locations..." onChange={handleChangeInput}></input>
    </div>
  <table id="tableWrapper">
  <tbody>
  <tr>
    <th>Location Number</th>
    <th>Location Code</th>
    <th>Address</th>
    <th>Location Phone #</th>
    {/* <th>Add Additional Pick-Up</th> */}
  </tr>
    {filteredLocations.length > 0 && filteredLocations.map((location, idx) => {
      const locationId = getFieldValue(location, 3) || null;
      const portalApp = getFieldValue(location, '_portalApp') || 'waste';
      return (
        <tr key={locationId || idx} onClick={(e) => redirectToLocationPage(e, locationId, portalApp)} className="tableRow">
          <td className="tableCell">{getFieldValue(location, 66)}</td>
          <td className="tableCell">{getFieldValue(location, 35)}</td>
          <td className="tableCell">{formatAddress(getFieldValue(location, 8))}</td>
          <td className="tableCell">{getFieldValue(location, 36)}</td>
          {/* <td className="tableCell"><button onClick={handleRedirectCreateTicket} className="mainButton">+ Create Service Request</button></td> */}
        </tr>
      )
    })}
    </tbody>
</table>
</div>
  </div>
  )
}
